exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".camera-chart2 .card-item[data-v-65c49024] {\n  height: 270px;\n  border-radius: 10px;\n}\n.camera-chart2[data-v-65c49024] .antv-chart-mini {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.camera-chart2[data-v-65c49024] .antv-chart-mini .chart-wrapper {\n  position: relative;\n  bottom: 0;\n  width: 100%;\n}\n.camera-chart2 .table-card[data-v-65c49024] {\n  padding: 25px 20px;\n  margin-top: 20px;\n  background-color: #fff;\n  border-radius: 10px;\n}\n", ""]);

// exports
